/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ChallengeCelebrationModalQueryVariables = Exact<{ [key: string]: never }>;

export type ChallengeCelebrationModalQuery = {
  readonly challengeCelebrationV2: {
    readonly title: string;
    readonly celebrationCopy: string;
    readonly expirationDate: string | null;
    readonly challengesIds: ReadonlyArray<string>;
  } | null;
};

export const ChallengeCelebrationModalDocument = gql`
  query ChallengeCelebrationModal {
    challengeCelebrationV2 {
      title
      celebrationCopy
      expirationDate
      challengesIds
    }
  }
`;

export function useChallengeCelebrationModalQuery(
  options?: Omit<Urql.UseQueryArgs<ChallengeCelebrationModalQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ChallengeCelebrationModalQuery, ChallengeCelebrationModalQueryVariables>({
    query: ChallengeCelebrationModalDocument,
    ...options,
  });
}
